import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "container is-fluid" }
const _hoisted_2 = { class: "container__section" }
const _hoisted_3 = { class: "container__titles" }
const _hoisted_4 = { class: "title is-2" }
const _hoisted_5 = { class: "subtitle is-6" }
const _hoisted_6 = {
  key: 0,
  class: "container__buttons"
}
const _hoisted_7 = {
  key: 0,
  class: "tabs"
}

import { TabItem } from './tabItem';
import { HeaderButton } from './headerButton';
import { useRoute, useRouter } from 'vue-router';
import { computed, PropType } from 'vue';
import { useAuth } from '@/authentication/useAuth';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  tabs: {
    type: Array as PropType<TabItem[]>,
  },
  buttons: {
    type: Array as PropType<HeaderButton[]>,
  },
},
  setup(__props) {

const props = __props;

const { currentRoute, getRoutes } = useRouter();
const route = useRoute();
const { isPlatformAdmin } = useAuth();

const activeRouteName = computed(() => String(route?.name || ''));
const isPlatformAdminRoute = computed(() => activeRouteName.value.startsWith('platform-admin'));
const usePlatformAdminHeading = computed(() => isPlatformAdmin.value && isPlatformAdminRoute.value);

function hasTabs() {
  return props.tabs && props.tabs.length > 0;
}

function hasButtons() {
  return !!props.buttons && props.buttons.length > 0;
}

function isTabActive(tab: TabItem): boolean {
  return isTabTheActiveRoute(tab) || isNoExactMatchAndActiveRouteBeginsWithTabsPath(tab);
}

function isTabTheActiveRoute(tab: TabItem) {
  return activeRouteName.value === tab.route;
}

function isNoExactMatchAndActiveRouteBeginsWithTabsPath(tab: TabItem) {
  return !isAnyTabActive() && doesActiveRouteBeginWithPath(tab.route);
}

function isAnyTabActive(): boolean {
  return props.tabs.filter((tab: TabItem) => activeRouteName.value === tab.route).length > 0;
}

function doesActiveRouteBeginWithPath(routeName: string): boolean {
  const path: string = getRoutePath(routeName);
  return !!currentRoute.value?.path && currentRoute.value?.path.indexOf(path) === 0;
}

function getRoutePath(routeName: string): string {
  const allRoutes = getRoutes();
  const matchedRoutes = allRoutes.filter((route) => route.name === routeName || route.name === '/' + routeName);
  return matchedRoutes.length === 1 ? matchedRoutes[0].path : '';
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["section primary-header", { 'has-tabs': hasTabs(), 'is-platform-admin': usePlatformAdminHeading.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.title), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.description), 1)
        ]),
        (hasButtons())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: button.content
                }, [
                  _createVNode(_component_n_button, {
                    variant: button.variant,
                    onClick: button.clickHandler
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(button.content), 1)
                    ]),
                    _: 2
                  }, 1032, ["variant", "onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (hasTabs())
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: tab.name,
                  class: _normalizeClass({ 'is-active': isTabActive(tab) })
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: tab.route }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "tab-icons")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})